/**
 * Contact block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS. GSAP is lazy-loaded
 * only when the block is present and motion is allowed.
 */

import './index.scss';

const contactBlocks = document.querySelectorAll('.contact');

if (contactBlocks.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!reduceMotion) {
		contactBlocks.forEach((block) => {
			if (block.getBoundingClientRect().bottom > 0) {
				block.dataset.animate = '';
			}
		});

		(async () => {
			const { gsap } = await import('gsap');
			const { ScrollTrigger } = await import('gsap/ScrollTrigger');

			gsap.registerPlugin(ScrollTrigger);

			document.querySelectorAll('.contact[data-animate]').forEach((block) => {
				const ctx = gsap.context(() => {
					const detailBlocks = block.querySelectorAll('.contact__block');
					const form = block.querySelector('.contact__form');

					if (detailBlocks.length) {
						gsap.to(detailBlocks, {
							opacity: 1,
							y: 0,
							duration: 0.8,
							ease: 'power3.out',
							stagger: 0.12,
							scrollTrigger: {
								trigger: block.querySelector('.contact__details'),
								start: 'top 90%',
								once: true,
							},
						});
					}

					if (form) {
						gsap.to(form, {
							opacity: 1,
							y: 0,
							duration: 0.8,
							ease: 'power3.out',
							scrollTrigger: {
								trigger: form,
								start: 'top 90%',
								once: true,
							},
						});
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
